import { Dic } from '$utils'
export const tableOption = function (that) {
  return {
    add: '新增',
    view: '详情',
    emptyText: that.$t("deviceAccess.message.nodata"),
    stripe: true,
    maxHeight: "100%",
    page: true,
    align: "center",
    menuAlign: "center",
    labelSuffix: '：',
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: '120px',
    column: [
      {
        label: 'NVR名称',
        prop: "deviceName",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        rules: [{ required: true, message: '请输入NVR名称', trigger: 'blur' }]
      },
      {
        label: '厂商',
        prop: "factoryName",
        overHidden: true,
        viewDisplay: true,
        addDisplay: true,
        type: 'select',
        dicData: [
          {
            label: '海康威视',
            value: 'HIKVISION'
          },
          {
            label: '华为',
            value: 'HUAWEI'
          }
        ],
        rules: [{ required: true, message: '请选择厂商', trigger: 'blur' }]
      },
      {
        label: 'IP',
        prop: "deviceHost",
        overHidden: true,
        viewDisplay: true,
        addDisplay: true,
        rules: [{ required: true, message: '请输入IP', trigger: 'blur' }]
      },
      {
        label: '平台用户名',
        prop: "userName",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        hide: true,
        rules: [
          {
            required: true,
            message: '请输入平台用户名',
            trigger: 'blur'
          },
          {
            required: true,
            min: 4,
            max: 30,
            message: '长度在 4 到 30 个字符',
            trigger: 'blur'
          }
        ],
      },
      {
        label: '平台密码',
        prop: "password",
        type: 'password',
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        hide: true,
        rules: [
          {
            required: true,
            message: '请输入平台密码',
            trigger: 'blur'
          },
          {
            min: 4,
            max: 30,
            message: '长度在 4 到 30 个字符',
            trigger: 'blur'
          }
        ],
      },
      {
        label: '边缘节点ID',
        prop: "edgeNodeCode",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        type: 'select',
        dicData: [
          {
            label: '海康威视',
            value: 'HIKVISION'
          },
          {
            label: '华为',
            value: 'HUAWEI'
          }
        ],
        rules: [{ required: true, message: '请选择边缘节点ID', trigger: 'blur' }]

      },
      {
        label: "接入协议",
        prop: "accessProtocol",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        type: 'select',
        dicData: Dic.find('SENU093'),
        // dicData: [
        //   {
        //     label: '厂商私有SDK',
        //     value: 'SDK'
        //   },
        //   {
        //     label: 'onvif协议',
        //     value: 'ONVIF'
        //   },
        //   {
        //     label: '国标28181协议',
        //     value: 'GB28181'
        //   }
        // ],
      },
      {
        label: "状态",
        prop: "status",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        type: 'select',
        dicData: [
          {
            label: '在线',
            value: '1'
          },
          {
            label: '离线',
            value: '0'
          }
        ],
        formatter: function (row, value) {
          return Number(value) === 1 ? '在线' : '离线'
        },
        viewFormatter: (row, value) => {
          return Number(value) === 1 ? '在线' : '离线'
        },
      },
      {
        label: '录入时间',
        prop: "createTime",
        overHidden: true,
        addDisplay: false,
        viewDisplay: true,
        hide: true
      },
      {
        label: '描述',
        prop: "thirdDeviceDesc",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        span: 24,
        type: 'textarea',
        hide: true,
        minRows: 3,
        maxlength: 200,
      },
    ],
  }
}
